import React, {Component} from 'react';
import {observer, inject} from 'mobx-react';
import ReactGA from 'react-ga';
import config from 'config'

@inject('store')
@observer
class ProductDetail extends Component {
    constructor(props) {
        super(props)
        this.state = {
            id: this.props.match.params.id,
            ProductsVal: {
                productdetail: {
                    loanamount: "",
                    interestRate: "",
                    loanterm: "",


                },
                mandatoryrequir: {
                    vechiledoc: "",
                    others: "",
                },
                elegibilityCrit: {
                    customerage: "",
                    customertype: "",
                    docrequired: "",
                    minmonthincome: "",
                },
                applicableChg: {
                    additionalint: "",
                    foreclousechg: "",
                    legalchg: "",
                    loancanclechg: "",
                    peremibouncechg: "",
                    processing_fee: "",
                },
            },

        }
    }


    productDetails = () => {
        fetch(`${config.REV_URL}/getproductById/${this.state.id}`)
            .then((response) => {
                return response.json();
            })
            .then((response) => {
                console.log('jor', response)
                this.setState({
                    ProductsVal: response.data
                })
            })
    }


    componentDidMount() {
        this.initializeReactGA();
        window.scrollTo(0, 0);
        this.props.store.homeType(false);
        this.productDetails()
    }

    initializeReactGA() {
        ReactGA.initialize('UA-128486561-1');
        ReactGA.pageview('/product');
    }


    render() {

        if (this.state.ProductsVal.product_name === "Electric Two Wheeler Lease") {
            return (
                <div>
                    <section className="pdtb-20">
                        <div className="container">
                            <div className="row mgt-5">
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <h2 className="fz-25 color_main bold notflor">
                                        {this.state.ProductsVal.product_name}
                                    </h2>
                                    <p>
                                        {this.state.ProductsVal.description}
                                    </p>
                                    <p className=" text-uppercase fz-15">
                                        <b>Product Purpose</b>
                                    </p>
                                    <p>
                                        {this.state.ProductsVal.productPurpose}
                                    </p>
                                </div>
                                <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                    <table className="table table-bordered">
                                        <tbody>
                                        <tr>
                                            <td colSpan="2" style={{'padding': '0px'}}>
                                                <table width="100%">
                                                    <tbody>
                                                    <tr>
                                                        <td colSpan="2"
                                                            style={{'background': '#f1f1f1'}}>
                                                            <b>Product details</b>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Monthly Lease Rental</td>
                                                        <td>{this.state.ProductsVal.productdetail.leaseamount}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Lease Term</td>
                                                        <td>{this.state.ProductsVal.productdetail.leaseterm} </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan="2" style={{'padding': '0px'}}>
                                                <table width="100%">
                                                    <tbody>
                                                    <tr>
                                                        <td colSpan="2"
                                                            style={{'background': '#f1f1f1'}}><b>Eligibility
                                                            Criteria</b></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Customer Age</td>
                                                        <td>{this.state.ProductsVal.elegibilityCrit.customerage}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Minimum monthly income</td>
                                                        <td>{this.state.ProductsVal.elegibilityCrit.minmonthincome}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Aggregator aggrement</td>
                                                        <td>{this.state.ProductsVal.elegibilityCrit.aggregatoragreement}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Documents Required</td>
                                                        <td>{this.state.ProductsVal.elegibilityCrit.docrequired}</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td colSpan="2" style={{'padding': '0px'}}>
                                                <table width="100%">
                                                    <tbody>
                                                    <tr>
                                                        <td colSpan="2"
                                                            style={{'background': '#f1f1f1'}}><b>Applicable
                                                            Charges</b></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Processing fee/origination charges</td>
                                                        <td>{this.state.ProductsVal.applicableChg.processing_fee}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Late payment fees</td>
                                                        <td>{this.state.ProductsVal.applicableChg.latepaymentfees}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Legal/incidental charges</td>
                                                        <td>{this.state.ProductsVal.applicableChg.legalchg}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>End of lease buy-back price</td>
                                                        <td>{this.state.ProductsVal.applicableChg.endOfLeaseBuyBack}</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>

                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        </div>

                    </section>
                </div>

            )
        } else {
            return (
                <div>
                    <section className="pdtb-20">
                        <div className="container">

                            <div className="row mgt-5">
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <h2 className="fz-25 color_main bold notflor">
                                        {this.state.ProductsVal.product_name}
                                    </h2>
                                    <p>
                                        {this.state.ProductsVal.description}
                                    </p>
                                    <p className=" text-uppercase fz-15">
                                        <b>Product Purpose</b>
                                    </p>
                                    <p>
                                        {this.state.ProductsVal.productPurpose}
                                    </p>
                                </div>

                                <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                    <table className="table table-bordered">
                                        <tbody>

                                        <tr>
                                            <td colSpan="2" style={{'padding': '0px'}}>
                                                <table width="100%">
                                                    <tbody>
                                                    <tr>
                                                        <td colSpan="2" style={{'background': '#f1f1f1'}}>
                                                            <b>Product details</b>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Loan Amount</td>
                                                        <td>{this.state.ProductsVal.productdetail.loanamount}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Loan Term</td>
                                                        <td>{this.state.ProductsVal.productdetail.loanterm} </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Interest Rate</td>
                                                        <td>{this.state.ProductsVal.productdetail.interestRate}</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                        {this.state.ProductsVal.mandatoryrequir ? (
                                            <tr>
                                                <td colSpan="2" style={{'padding': '0px'}}>
                                                    <table width="100%">
                                                        <tbody>
                                                        <tr>
                                                            <td colSpan="2" style={{'background': '#f1f1f1'}}><b>Mandatory
                                                                requirements </b></td>
                                                        </tr>
                                                        <tr>
                                                            <td>Vehicle Documents</td>
                                                            <td>{this.state.ProductsVal.mandatoryrequir.vechiledoc}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Others</td>
                                                            <td>{this.state.ProductsVal.mandatoryrequir.others}</td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        ) : (
                                            <tr>
                                                <td colSpan="2" style={{'padding': '0px'}}>
                                                    <table width="100%">
                                                        <tbody>
                                                        <tr>
                                                            <td colSpan="2" style={{'background': '#f1f1f1'}}><b>Mandatory
                                                                requirements </b></td>
                                                        </tr>
                                                        <tr>
                                                            <td>Vehicle Documents</td>
                                                            <td></td>
                                                        </tr>
                                                        <tr>
                                                            <td>Others</td>
                                                            <td></td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        )}

                                        <tr>
                                            <td colSpan="2" style={{'padding': '0px'}}>
                                                <table width="100%">
                                                    <tbody>
                                                    <tr>
                                                        <td colSpan="2" style={{'background': '#f1f1f1'}}><b>Eligibility
                                                            Criteria</b></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Customer Age</td>
                                                        <td>{this.state.ProductsVal.elegibilityCrit.customerage}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Minimum monthly income</td>
                                                        <td>{this.state.ProductsVal.elegibilityCrit.minmonthincome}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Documents Required</td>
                                                        <td>{this.state.ProductsVal.elegibilityCrit.docrequired}</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan="2" style={{'padding': '0px'}}>
                                                <table width="100%">
                                                    <tbody>
                                                    <tr>
                                                        <td colSpan="2" style={{'background': '#f1f1f1'}}><b>Applicable
                                                            Charges</b></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Processing fee/origination charges</td>
                                                        <td>{this.state.ProductsVal.applicableChg.processing_fee}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Foreclosure charges</td>
                                                        <td>{this.state.ProductsVal.applicableChg.foreclousechg}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Additional interest on late payment of EMI</td>
                                                        <td>{this.state.ProductsVal.applicableChg.additionalint}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Per EMI bounce charge</td>
                                                        <td>{this.state.ProductsVal.applicableChg.peremibouncechg}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Legal/incidental charges</td>
                                                        <td>{this.state.ProductsVal.applicableChg.legalchg}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Loan cancellation charges</td>
                                                        <td>{this.state.ProductsVal.applicableChg.loancanclechg}</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>

                                        </tbody>
                                    </table>

                                </div>

                            </div>

                        </div>
                    </section>
                </div>

            )
        }

    }
}


export default ProductDetail;



// WEBPACK FOOTER //
// ./src/components/ProductDetail.js